import {
  setActiveDataAmo,
  setDataAmo,
  setIsErrorAmo,
} from "../../../../store/slices/amoSlice";
import { removeUser } from "../../../../store/slices/userSlice";
import { errorToast } from "../../../methods/toast";
import { $authHost } from "../../http";

let userId = localStorage.getItem("@storage_User_Id");

export const initAmo = (dataReq, setLoading, setIsConnected) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/amo-crm/create`,
        dataReq
      );

      if (data.code === 200) {
        setIsConnected(true);
        dispatch(getIntegrationsAmoList(userId));
        // console.log("init amo", data);
      } else {
        errorToast("Ошибка инициализации AmoCRM");
      }
    } catch (error) {
      if (!error.response) {
        errorToast("Ошибка сети. Проверьте подключение.");
      } else if (error.response.status === 401) {
        dispatch(removeUser());
      } else if (error.response.status === 500) {
        errorToast("Ошибка сервера. Попробуйте позже.");
      } else if (error.response.data?.message === "error: invalid api url") {
        errorToast("Неверный API URL, повторите попытку.");
      } else if (
        error.response.data?.message?.includes("TLS handshake timeout")
      ) {
        errorToast(
          "Произошла ошибка соединения с AmoCRM. Повторите попытку позже."
        );
      }

      console.error("initAmo error:", error);
    } finally {
      setLoading(false);
    }
  };
};

// Удаление интеграции
export const deleteIntegrationAmo = (integrationId, setLoading, navigate) => {
  return async (dispatch) => {
    setLoading(true);
    try {
      const { data } = await $authHost.post(
        `/integrations/amo-crm/delete?userId=${userId}&integrationId=${integrationId}`
      );
      if (data.code === 200) {
        dispatch(setActiveDataAmo(null));
        localStorage.removeItem("dataAmo");
        // dispatch(getIntegrationsBitrixList(dataReq.userId));
        navigate("/integration");
        setLoading(false);
      } else {
        setLoading(false);
        errorToast("Ошибка удаления интеграции");
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("deleteIntegrationBitrix error:", error);
    }
  };
};

// Получение конкретной интеграции
export const getIntegrationAmo = (
  userId,
  integrationId,
  setLoading = () => {}
) => {
  return async (dispatch) => {
    dispatch(setIsErrorAmo(false));
    setLoading(true);
    try {
      const { data } = await $authHost.get(
        `/integrations/amo-crm?userId=${userId}&integrationId=${integrationId}`
      );
      if (data.code === 200) {
        setLoading(false);
        dispatch(
          setActiveDataAmo({
            dataUser: data.amoCRM,
            dataCategories: data.pipelines,
          })
        );
        localStorage.setItem(
          "activeAmo",
          JSON.stringify({
            dataUser: data.amoCRM,
            dataCategories: data.pipelines,
          })
        );
        console.log("data getIntegrationAmo", data);
      } else {
        setLoading(false);
        errorToast("Не удалось получить интеграцию с AmoCRM");
      }
    } catch (error) {
      dispatch(setIsErrorAmo(false));
      setLoading(false);
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("getIntegrationAmo error:", error);
    }
  };
};

// Получение списка интеграций
export const getIntegrationsAmoList = (userId) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.get(
        `/integrations/amo-crm/list?userId=${userId}`
      );
      if (data.code === 200) {
        dispatch(setDataAmo(data.amoCRMList));
        localStorage.setItem("dataAmo", JSON.stringify(data.amoCRMList));
        // console.log("amo list", data);
      } else {
        errorToast("Не удалось загрузить список интеграций AmoCRM");
      }
      // console.log("getIntegrationsBitrixList", data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("getIntegrationsAmoList error:", error);
    }
  };
};

// Обновление воронки
export const updatePipelineAmo = (dataReq) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/amo-crm/pipeline`,
        dataReq
      );
      if (data.code === 200) {
        dispatch(getIntegrationsAmoList(userId));
        console.log("updatePipelineAmo", data);
      } else {
        errorToast("Не удалось обновить воронку AmoCRM");
      }
      // console.log("updatePipelineAmo", data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
      console.log("updatePipelineAmo error:", error);
    }
  };
};

// // Обновление этапа воронки
export const updatePipelineStatusAmo = (dataReq) => {
  return async (dispatch) => {
    try {
      const { data } = await $authHost.put(
        `/integrations/amo-crm/pipeline-status`,
        dataReq
      );
      if (data.code === 200) {
        dispatch(getIntegrationsAmoList(userId));
        console.log("updatePipelineStatusAmo", data);
      } else {
        errorToast("Не удалось обновить этап воронки AmoCRM");
      }
      // console.log("updatePipelineStatusAmo", data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          dispatch(removeUser());
        } else if (error.response.status === 500) {
          errorToast("Ошибка сервера, попробуйте позже");
        }
      } else if (error.request) {
        errorToast("Нет ответа от сервера, проверьте соединение");
      } else {
        errorToast("Произошла неизвестная ошибка");
      }
    }
  };
};
// export const updateCategoryStageBitrix = (dataReq) => {
//   return async (dispatch) => {
//     try {
//       const { data } = await $authHost.put(
//         `/integrations/bitrix/category-stage`,
//         dataReq
//       );
//       if (data.code === 200) {
//         // console.log("data updateCategoryStageBitrix", data);

//         dispatch(getIntegrationsBitrixList(userId));
//       } else {
//         errorToast("Не удалось обновить этап воронки Bitrix");
//       }
//     } catch (error) {
//       if (error.response) {
//         if (error.response.status === 401) {
//           dispatch(removeUser());
//         } else if (
//           error.response.status === 400 &&
//           error.response.data.message === "error: invalid UUID length: 0"
//         ) {
//           errorToast("Выберите ассистента");
//         } else if (error.response.status === 500) {
//           errorToast("Ошибка сервера, попробуйте позже");
//         }
//       } else if (error.request) {
//         errorToast("Нет ответа от сервера, проверьте соединение");
//       } else {
//         errorToast("Произошла неизвестная ошибка");
//       }
//       console.log("updateCategoryStageBitrix error:", error);
//     }
//   };
// };
